import { config } from "./config";
import { tokens } from "./tokens";
import axios from "axios";
import { handleAxiosError } from "./utils/error.utils";
import { UnexpectedAPIError } from "./errors";
export const register = (() => {
    async function request(email, password, metadata) {
        try {
            const url = `${baseUrl()}/request`;
            const data = { email, password, metadata };
            const response = await axios.post(url, data);
            if (response.status === 200) {
                return tokens.set(response.headers);
            }
            else {
                throw response.data;
            }
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function confirm(token) {
        const _axios = axios.create();
        try {
            const url = `${baseUrl()}/confirm`;
            const data = {};
            const requestConfig = { headers: { Authorization: `Bearer ${token}` } };
            const response = await _axios.post(url, data, requestConfig);
            if (response.status === 200) {
                return tokens.set(response.headers);
            }
            else {
                throw response.data;
            }
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    function baseUrl() {
        return `${config.fullUrl()}/register`;
    }
    return {
        request: request,
        confirm: confirm,
    };
})();
